module.exports = __webpack_public_path__ + "img/RB60.png";